/*
 * The only purpose of this file is to kick off the application's top-level
 * controller at the appropriate time. All other code should be written as
 * separate components in their own files.
 *
 * @fileOverview Application kick-off
 */

window.$ = window.jQuery = require('jquery');

import Vue from 'vue';

import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';

// Handlebars and default vue delimiters conflict.
Vue.options.delimiters = ['${', '}'];

// Uncomment the line below to get performance counters under timings.
// Vue.config.performance = true;

import registerModal from 'components/modules/register-modal/register-modal';
import bookmarkArticle from 'components/modules/bookmark-article/bookmark-article';
import bookmarkMenu from 'components/modules/bookmark-menu/bookmark-menu';
import createFolder from 'components/modules/create-folder/create-folder';
import renameFolder from 'components/modules/rename-folder/rename-folder';
import moveBookmark from 'components/modules/move-bookmark/move-bookmark';
import folderList from 'components/modules/folder-list/folder-list';
import folderListContent from 'components/modules/folder-list-content/folder-list-content';
import folderOptions from 'components/modules/folder-options/folder-options';
import bookmarkOptions from 'components/modules/bookmark-options/bookmark-options';
import Accordion from 'components/modules/accordions-modals/accordion/accordion';
import Amount from 'components/modules/donate/partials/amount/amount';
import Alert from 'components/modules/content/alert/alert';
import Aside from 'components/template/aside';
import Banner from 'components/modules/callouts/banner/banner';
import BasicCarousel from 'components/modules/carousels/basicCarousel/basicCarousel';
import ButtonLoader from 'components/foundation/atoms/button/button--loader';
import Checkbox from 'components/foundation/forms/checkbox/checkbox';
import ComplexRadio from 'components/foundation/forms/complexRadio/complexRadio';
import cookieDialog from 'components/modules/utility/cookieDialog/cookieDialog';
import animations from 'components/modules/utility/animations/animations';
import Date from 'components/foundation/forms/date/date';
import Dropdown from 'components/foundation/forms/dropdown/dropdown';
import EmployerMatchResults from 'components/modules/donate/partials/employerMatchResults/employerMatchResults';
import FeaturedCarousel from 'components/modules/carousels/featuredCarousel/featuredCarousel';
import Filter from 'components/foundation/forms/field/filter';
import Filters from 'components/modules/utility/filters/filters';
import Form from 'components/foundation/forms/form/form';
import FormContact from 'components/foundation/forms/form/form--contact';
import FormFormAssembly from 'components/foundation/forms/form/form--form-assembly';
import FormScribe from 'components/foundation/forms/form/form--scribe';
import FormWebinar from 'components/foundation/forms/form/form--webinar';
import FooterSocial from 'components/modules/navigation/footer/footerSocial';
import Gallery from 'components/compositions/gallery/gallery';
import HeroPodcast from 'components/modules/hero/heroPodcast';
import Homepage from 'components/pages/homepage/homepage';
import ImageCaption from 'components/foundation/misc/imageCaption/imageCaption';
import KeyValueCache from 'utils/KeyValueCache'
import Modal from 'components/modules/accordions-modals/modals/modal/modal.mixin.js';
import ModalForm from 'components/modules/accordions-modals/modals/modal/modal--form';
import Nav from 'components/modules/navigation/nav/nav';
import NewsCarousel from 'components/modules/carousels/newsCarousel/newsCarousel';
import Newsletter from 'components/foundation/forms/form/form--newsletter';
import Quarantine from 'components/foundation/quarantine/quarantine';
import Radio from 'components/foundation/forms/radio/radio';
import VueRecaptcha from 'vue-recaptcha';
import Search from 'components/modules/utility/search/search';
import SearchEmployer from 'components/modules/utility/search/searchEmployer';
import SearchFilterGrants from 'components/modules/utility/search/searchFilterGrants';
import SearchPill from 'components/foundation/forms/searchPill/searchPill';
import SearchPlaces from 'components/modules/utility/search/searchPlaces';
import SearchResultsAnalytics from 'components/modules/utility/search/searchResultsAnalytics';
import SearchTeams from 'components/modules/utility/search/searchTeams';
import Share from 'components/modules/utility/share/share';
import Slider from 'components/foundation/forms/slider/slider';
import SplashScreen from 'components/modules/callouts/splashScreen/splashScreen';
import StickyNav from 'components/modules/navigation/stickyNav/stickyNav';
import Table from 'components/modules/table/table';
import Tabs from 'components/modules/navigation/tabs/tabs';
import Tasks from 'components/modules/drupal/tasks/tasks';
import TimelineAnchorLinks from 'components/modules/timeline/timelineAnchorLinks/timelineAnchorLinks';
import Timeline from 'components/compositions/timeline/timeline';
import Tooltip from 'components/modules/accordions-modals/modals/modal/modal--tooltip';
import ThemeToggle from 'components/_partials/themeToggle/themeToggle';
import PasswordShow from 'components/foundation/misc/passwordShow/passwordShow';
import SignUp from 'components/modules/sign-up/sign-up';
import UserLogin from 'components/modules/user-login/user-login';

// New Components
import Listings from 'components/modules/listings/listings';
import SummaryDetails from 'components/modules/summary-details/summary-details';
import SearchBar from 'components/modules/search-bar/search-bar';
import Tag from 'components/modules/tag/tag';
import advancedFilters from 'components/modules/advanced-filters/advanced-filters';
import authorSearchbar from 'components/modules/author-searchbar/author-searchbar';
import journalSearchbar from 'components/modules/journal-searchbar/journal-searchbar';
import authorAutoComplete from 'components/modules/author-auto-complete/author-auto-complete';
import journalAutoComplete from 'components/modules/journal-auto-complete/journal-auto-complete';
import filterDropdown from 'components/modules/filter-dropdown/filter-dropdown';

import Vuex from 'vuex';

export default {
  buildVue(store) {
    Vue.component('modal-vue', Modal);
    Vue.use(Vuex);

    // One main app vue that attaches to a wrapper element.
    const app = new Vue({
      el: '#app',
      components: {
        VueRecaptcha
      },
      store,
      mounted() {
        this.$root.domCache = new KeyValueCache();
      }
    });

    document.addEventListener('DOMContentLoaded', function () {
      svg4everybody();
      objectFitImages();
    });

  }
}
